import { lazy } from "react";

const MainRoutes = [
  {
    path: "/admin/dashboard",
    public:true,
    acl: "view-dashboard",
    component: lazy(() => import("@src/views/BackOffice/dashboard")),
  },
  {
    exact: true,
    path: "/admin/:state/statistics",
    acl: "view-statistics",
    component: lazy(() => import("@src/views/BackOffice/state")),
  },
  {
    path: "/admin/profile",
    acl: "view-profile-admin",
    component: lazy(() =>
      import("@src/views/BackOffice/authentification/account-settings")
    ),
  },
  {
    path: "/admin/permission",
    acl: "view-permissions",
    component: lazy(() =>
      import("@src/views/BackOffice/access_control/permissions")
    ),
  },
  {
    exact: true,
    path: "/admin/roles",
    acl: "view-roles",
    component: lazy(() => import("@src/views/BackOffice/access_control/roles")),
  },
  {
    exact: true,
    path: "/admin/roles/usersByRole/:id",
    acl: "view-users-role-id",
    component: lazy(() =>
      import("@src/views/BackOffice/access_control/usersByRole/UsersByRoleList")
    ),
  },
  {
    exact: true,
    path: "/admin/stuff/users_by_role/:id",
    acl: "view-stuff-users-id",
    component: lazy(() =>
      import("@src/views/BackOffice/access_control/usersByRole/UsersByRoleList")
    ),
  },

  {
    path: "/admin/modals",
    acl: "view-modals",
    component: lazy(() =>
      import("@src/views/BackOffice/access_control/modals")
    ),
  },
  {
    path: "/admin/chat/public",
    appLayout: true,
    className: "chat-application",
    acl: "public-chat",
    component: lazy(() => import("@src/views/BackOffice/chat/public")),
  },
  {
    path: "/admin/chat/private",
    appLayout: true,
    className: "chat-application",
    acl: "private-chat",
    component: lazy(() => import("@src/views/BackOffice/chat/private")),
  },
  {
    exact: true,
    path: "/admin/users/list",
    acl: "view-users",
    component: lazy(() =>
      import("@src/views/BackOffice/access_control/usersList/UsersList")
    ),
  },
  {
    exact: true,
    path: "/admin/users/profile/:id",
    acl: "user-profile",
    component: lazy(() =>
      import("@src/views/BackOffice/access_control/profileUser/ProfileUser")
    ),
  },
  {
    appLayout: true,
    className: "chat-application",
    path: "/admin/company/chat",
    acl: "company-chat",
    component: lazy(() => import("@src/views/BackOffice/company_Chat/chat")),
  },
];

export default MainRoutes;
